import theme from '../../layout/Theme';

const styles = (materialTheme) => ({
  parentBox: {
    display: 'flex',
    justifyContent: 'center',
    [theme.screenSize.laptop]: {
      marginTop: '10px',
      marginLeft: '20px',
    },
  },
  subParent: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
  },
  flexDisplay: {
    display: 'flex',
    justifyContent: 'center',
  },
  linkUnderline: {
    textDecoration: 'none',
    color: materialTheme.palette.common.white,
  },
  logoBox: {
    display: 'flex',
  },
  notFoundImg: {
    width: '100%',
    [theme.screenSize.mobile]: {
      marginTop: '30px',
    },
  },
  notFoundImgLarge: {
    width: '100%',
    height: 'auto',
    [theme.screenSize.mobile]: {
      marginTop: '30px',
    },
  },
  textColor: {
    color: materialTheme.palette.secondary.main,
    marginTop: '40px',
    marginBottom: '10px',
    fontSize: theme.font.size.xl3,
    [theme.screenSize.laptop]: {
      fontSize: theme.font.size.xl2,
    },
  },
  textFont: {
    fontSize: theme.font.size.xl6,
    fontWeight: theme.font.weight.medium,
    marginBottom: '20px',
    [theme.screenSize.laptop]: {
      margin: '10px 0px',
      fontSize: theme.font.size.xl4,
    },
  },
  sorryText: {
    color: materialTheme.palette.primary.dark,
    [theme.screenSize.mobile]: {
      width: '80%',
    },
  },
  buttonBackground: {
    backgroundColor: materialTheme.palette.primary.main,
    color: materialTheme.palette.common.white,
    '&:hover': {
      backgroundColor: materialTheme.palette.primary.main,
    },
    margin: '40px 0px',
    width: '50%',
    padding: '10px',
    [theme.screenSize.laptop]: {
      marginTop: '20px',
      marginBottom: '7px',
      width: '95%',
    },
  },
  imageOnLarge: {
    display: 'flex',
    width: '100%',
    [theme.screenSize.mobile]: {
      display: 'none',
    },
  },
  imageOnSmall: {
    display: 'none',
    [theme.screenSize.mobile]: {
      display: 'flex',
    },
  },
  leftGrid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default styles;
